import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import Toggle from 'components/toggle/toggle'
import { MainButton, CancelButton } from 'components/button'
import { localize } from 'helpers/translator'

import styles from './settings.scss'

class Settings extends PureComponent {
	constructor(props) {
		super(props)
		this.state = { settings: [] }

		this.toggleValue = this.toggleValue.bind(this)
		this.saveSettings = this.saveSettings.bind(this)
	}

	toggleValue(key) {
		const newSettings =
			this.state.settings.map(setting => {
				if (setting.key === key) {
					return {
						...setting,
						value: (setting.value === '1') ? '0' : '1',
					}
				} else {
					return {
						...setting,
					}
				}
			})

		this.setState({
			settings: newSettings,
		})
	}

	saveSettings() {
		var result = this.state.settings.reduce(function(map, setting) {
			map[setting.key] = setting.value
			return map
		}, {})
		this.props.saveSettings(result)
	}

	componentDidMount() {
		this.setState({
			settings: this.props.settings,
		})
	}

	render() {

		return (
			<div styleName='settings-wrapper'>
				<div styleName='settingsTitle'>
					<SecondaryTitle isCentered={true} >{this.props.title}</SecondaryTitle>
				</div>
				<div styleName='setting-toggle-container'>
					{this.state.settings.map(setting =>
						<div key={setting.key} styleName='message-container'>
							<div styleName='message'>
								<p>{setting.text}</p>
								<p styleName='description'>{setting.description}</p>
							</div>
							<div styleName='toggle-container'>
								<Toggle
									value={setting.value}
									onChange={() => {
										this.toggleValue(setting.key)
									}}
								/>
							</div>
						</div>
					)
					}
				</div>
				<div styleName='btn-container'>
					<div styleName='cancel-btn'>
						<CancelButton onClick={this.props.cancelSettings}>{localize('global_cancel')}</CancelButton>
					</div>
					<div styleName='save-btn'>
						<MainButton onClick={this.saveSettings}>{localize('global_save')}</MainButton>
					</div>
				</div>
			</div>
		)
	}
}

Settings.propTypes = {
	settings: PropTypes.arrayOf(PropTypes.shape({
		key: PropTypes.string,
		value: PropTypes.string,
		text: PropTypes.string,
		description: PropTypes.string,
	})),
}

export default connect(null, null)(CSSModules(Settings, styles, {allowMultiple: true}))
